export const DEFAULT_SITE_EVENTS_TAKE = 12
export const SITE_EVENTS_CARD_TAKE = 4
